// @flow

export default {
  wizard: {
    next: 'Weiter',
    back: 'Zurück',
    skip: 'Überspringen',
    sort: 'Sortieren',
    sorting: {
      'utility:desc': 'Beste Ergebnisse',
      'price:asc': 'Preis aufsteigend',
      'price:desc': 'Preis absteigend',
      'created_at:desc': 'Neueste zuerst',
      'customer_rating:desc': 'Kundenbewertung'
    },
    clickToAddFiles: 'Bitte klicken zum Hochladen. Alternativ kannst du die Dateien in das Feld ziehen.',
    searchFor: 'Suche nach ...',
    noSearchResults: 'Leider haben wir keine passenden Optionen gefunden. Bitte suchen Sie erneut.',
    loadMoreAnswerOptions: 'Keine passende Option dabei? Zeige alle Optionen an.',
    noRecommendationDescription: 'Oh nein, leider konnten wir keine Produkte finden, die auf deine Bedürfnisse passen.',
    noRecommendationDescription2: 'Bitte starte die Beratung neu.',
    noRecommendationRestartButtonTitle: 'Beratung neu starten',
    noRecommendationCloseButtonTitle: 'Schliessen',
    removeFile: 'Datei entfernen'
  },
  chatbot: {
    selectAll: 'Alle auswählen',
    none: 'Keines davon',
    confirmButton: 'Senden',
    customerServiceInputPlaceholder: 'Nachricht schreiben ... ',
    you: 'Du',
    restart: 'Neustarten',
    close: 'Schliessen',
    send: 'Senden',
    supportChat: 'Support Chat',
    honeypot: 'Bitte lassen Sie dieses Feld leer',
    scrollToTheLatestMessage: 'Zum neuesten Beitrag scrollen',
    removeFile: 'Datei entfernen'
  },
  product: {
    loadMore: 'Weitere Produkte anzeigen',
    badgeTitle: 'Unsere Empfehlung',
    ctaButtonTitle: 'Produkt entdecken',
    matchingPanelTitle: 'Passend auf dich abgestimmt',
    bestFit: 'Unsere Empfehlung',
    bestPrice: 'Günstigster Preis',
    bestFitForPrice: 'Beste Preis-Leistung',
    addToCartError: 'Das Hinzufügen zum Warenkorb hat leider nicht geklappt. Bitte versuchen Sie es erneut',
    addRoutineToCart: 'In den Warenkorb legen',
    explanationHeader: 'Weitere Produktinformationen:',
    emptyRoutineItem: 'Leider gibt es in dieser Kategorie kein passendes Produkt.'
  },
  tabBar: {
    chat: 'Chat',
    productAdvisor: 'Produktberatung'
  },
  recommender: {
    answerOptionLeadsToNoRecommendation: 'Diese Option würde leider zu keinem gewünschten Produkt führen. Du kannst in vorherigen Schritten deine Präferenz ändern um die Option zu aktivieren.'
  }
}
